import { render } from "./Bendicion.vue?vue&type=template&id=066a0f80"
import script from "./Bendicion.vue?vue&type=script&lang=js"
export * from "./Bendicion.vue?vue&type=script&lang=js"

import "./Bendicion.vue?vue&type=style&index=0&id=066a0f80&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__